import { Snackbar as MuiSnackbar } from '@mui/material';
import { motion } from 'framer-motion';
import React, { useEffect } from 'react';
import { useShallow } from 'zustand/react/shallow';
import useProductActionsStore from '../../stores/ProductActionsStore/productActions.store';

const MotionSnackbar = motion.create(MuiSnackbar);

interface IProductNotificationSnackbar {
  id?: string;
  open: boolean;
  onClose: (event: React.SyntheticEvent<any> | Event, reason: string) => void;
  autoHideDuration?: number;
  anchorOrigin: {
    vertical: 'top' | 'bottom';
    horizontal: 'left' | 'center' | 'right';
  };
  transitionProps?: any; // Adapte de acordo com o tipo correto
  initial?: Record<string, any>;
  animate?: Record<string, any>;
  exit?: Record<string, any>;
  children: React.ReactElement;
  className?: string;
}

const ProductNotificationSnackbar = ({
  id = '',
  open,
  onClose,
  autoHideDuration = 5000,
  anchorOrigin,
  transitionProps,
  initial,
  animate,
  exit,
  children,
  className = '',
}: IProductNotificationSnackbar) => {
  const { closeProductNotification, productNotificationState, setNotificationTimerIsValid } =
    useProductActionsStore(
      useShallow((state) => ({
        closeProductNotification: state.closeProductNotification,
        productNotificationState: state.productNotificationState,
        setNotificationTimerIsValid: state.setNotificationTimerIsValid,
      })),
    );

  useEffect(() => {
    if (productNotificationState.productAdd || productNotificationState.productAlready) {
      setNotificationTimerIsValid(true);
      const timeout = setTimeout(() => {
        closeProductNotification();
        setNotificationTimerIsValid(false);
      }, 4500);

      return () => {
        clearTimeout(timeout);
        setNotificationTimerIsValid(false);
      };
    }
  }, [productNotificationState]);

  return (
    <MotionSnackbar
      id={id}
      open={open}
      onClose={onClose}
      autoHideDuration={autoHideDuration}
      anchorOrigin={anchorOrigin}
      TransitionProps={transitionProps}
      transition={{ duration: 0.35, type: 'tween' }}
      initial={initial}
      animate={animate}
      exit={exit}
      className={className}
    >
      {children}
    </MotionSnackbar>
  );
};

export default ProductNotificationSnackbar;
